import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  changeSubuserStatus,
  getSubuserList,
} from "../../../actions/subuserAction";
import "../../SubAccount/subAccount.css";
import PrimaryButton from "../../Helpers/Buttons/PrimaryButton";
import { useState } from "react";

export default function UserTable({
  className,
  subuserList,
  loginId,
  userLevel,
  userEmail,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  {
    /*
  function handleInativeUserClick(subuser) {
    dispatch(changeSubuserStatus(subuser.userId)); //requestedUserId

    if (subuser.isActive) {
      alert(`The username '${subuser.loginId}' has been deactivated.`);
    } else {
      alert(`The username '${subuser.loginId}' has been activated.`);
    }

    // reload the list of subusers
    dispatch(getSubuserList());
  }
*/
  }

  const [dropdownIndex, setDropdownIndex] = useState(null);

  function handleStatusChange(subuser, status) {
    dispatch(changeSubuserStatus(subuser.userId));
    alert(
      `The username '${subuser.loginId}' has been ${
        status === "Active" ? "activated" : "deactivated"
      }.`
    );
    // reload the list of subusers
    dispatch(getSubuserList());

    setDropdownIndex(null); // 드롭다운 닫기
  }

  function handleEditUserClick(subuserId) {
    console.log("subuserId ", subuserId);
    navigate(`/edituser?subuserId=${subuserId}`);
  }

  function handleAddRoleClick() {
    navigate(`/addrole`);
  }

  function handleAddUserClick() {
    navigate(`/adduser`);
  }

  const handleCreateRoleClick = () => {
    navigate("/customerroles");
  };
  return (
    <div className={`table-container ${className || ""}`}>
      <div className="administrator-text">Administrator</div>
      <div className="staff-container">
        <div className="icon-stack">
          <div className="staff-icon">
            <div className="staff-text">STAFF</div>
          </div>
          <div className="buyer-icon">
            <div className="buyer-text">BUYER</div>
          </div>
          <div className="plus-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M13 8H8V13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13V8H1C0.734784 8 0.48043 7.89464 0.292893 7.70711C0.105357 7.51957 0 7.26522 0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289C0.48043 6.10536 0.734784 6 1 6H6V1C6 0.734784 6.10536 0.480429 6.29289 0.292893C6.48043 0.105357 6.73478 0 7 0C7.26522 0 7.51957 0.105357 7.70711 0.292893C7.89464 0.480429 8 0.734784 8 1V6H13C13.2652 6 13.5196 6.10536 13.7071 6.29289C13.8946 6.48043 14 6.73478 14 7C14 7.26522 13.8946 7.51957 13.7071 7.70711C13.5196 7.89464 13.2652 8 13 8Z"
                fill="#F49B3A"
              />
            </svg>
          </div>
          <div className="role-text">
            Create a role to give permissions to your team member
          </div>
        </div>

        <button className="create-button" onClick={handleCreateRoleClick}>
          Create
        </button>
      </div>
      <div className="members-container">
        <div className="members-inner-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.0003 0.000488281C19.6993 0.000488281 0.000610352 19.6992 0.000610352 44.0002C0.000610352 68.3012 19.6993 87.9999 44.0003 87.9999C68.3014 87.9999 88 68.3012 88 44.0002C88 19.6992 68.3014 0.000488281 44.0003 0.000488281ZM28.6004 33.0003C28.6004 30.9779 28.9988 28.9754 29.7727 27.107C30.5466 25.2386 31.6809 23.5409 33.111 22.1109C34.541 20.6809 36.2386 19.5465 38.107 18.7726C39.9754 17.9987 41.978 17.6004 44.0003 17.6004C46.0227 17.6004 48.0252 17.9987 49.8936 18.7726C51.762 19.5465 53.4597 20.6809 54.8897 22.1109C56.3197 23.5409 57.4541 25.2386 58.228 27.107C59.0019 28.9754 59.4002 30.9779 59.4002 33.0003C59.4002 37.0846 57.7777 41.0016 54.8897 43.8896C52.0017 46.7777 48.0846 48.4002 44.0003 48.4002C39.916 48.4002 35.999 46.7777 33.111 43.8896C30.2229 41.0016 28.6004 37.0846 28.6004 33.0003ZM71.5353 65.9297C68.2417 70.0728 64.0545 73.4182 59.2866 75.7161C54.5186 78.014 49.2931 79.2049 44.0003 79.2C38.7075 79.2049 33.482 78.014 28.7141 75.7161C23.9461 73.4182 19.759 70.0728 16.4653 65.9297C23.5977 60.8125 33.3304 57.2001 44.0003 57.2001C54.6703 57.2001 64.403 60.8125 71.5353 65.9297Z"
              fill="#363636"
            />
          </svg>
        </div>
        <div className="inner-text ">
          {userLevel === 0 ? <div>Admin</div> : <div>Sub-User</div>}
          <div className="name-text">{loginId}</div>
          <div className="email-text">{userEmail}</div>
        </div>
      </div>
      <div className="members-text">Sub-Users</div>
      <div className="w-full sm:flex justify-between">
        <div className="flex space-x-2.5 items-center">
          <PrimaryButton
            onClick={handleAddUserClick}
            style={{ marginBottom: "20px" }}
          >
            Add Sub-Users
          </PrimaryButton>
        </div>
      </div>
      <div className="table-wrapper">
        <div className="table-header">
          <div className="header-item">Username</div>
          <div className="header-item">Email</div>
          <div className="header-item">Role</div>
          <div className="header-item">Status</div>
          <div className="header-item">Edit</div>
        </div>
        {subuserList &&
          subuserList.map((subuser, index) => (
            <div key={index} className="table-row">
              <div className="row-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                  style={{ marginRight: "5px" }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.2511 0C3.66115 0 0.751099 2.91005 0.751099 6.5C0.751099 10.0899 3.66115 13 7.2511 13C10.841 13 13.7511 10.0899 13.7511 6.5C13.7511 2.91005 10.841 0 7.2511 0ZM4.9761 4.875C4.9761 4.57624 5.03494 4.28041 5.14927 4.0044C5.2636 3.72838 5.43118 3.47759 5.64243 3.26633C5.85368 3.05508 6.10448 2.8875 6.38049 2.77317C6.65651 2.65884 6.95234 2.6 7.2511 2.6C7.54986 2.6 7.84569 2.65884 8.1217 2.77317C8.39772 2.8875 8.64851 3.05508 8.85977 3.26633C9.07102 3.47759 9.2386 3.72838 9.35292 4.0044C9.46725 4.28041 9.5261 4.57624 9.5261 4.875C9.5261 5.47837 9.28641 6.05702 8.85977 6.48367C8.43312 6.91031 7.85447 7.15 7.2511 7.15C6.64773 7.15 6.06908 6.91031 5.64243 6.48367C5.21579 6.05702 4.9761 5.47837 4.9761 4.875ZM11.3188 9.7396C10.8322 10.3517 10.2137 10.8459 9.50931 11.1853C8.80495 11.5248 8.03299 11.7007 7.2511 11.7C6.4692 11.7007 5.69725 11.5248 4.99289 11.1853C4.28853 10.8459 3.66996 10.3517 3.1834 9.7396C4.23705 8.98365 5.67485 8.45 7.2511 8.45C8.82735 8.45 10.2651 8.98365 11.3188 9.7396Z"
                    fill="#0B0B0B"
                  />
                </svg>
                {subuser.loginId}
              </div>
              <div className="row-item">{subuser.contactEmail}</div>
              <div className="row-item">{subuser.roleName}</div>
              <div className="row-item">
                <div className="status-container">
                  <button
                    className={`status-button ${
                      subuser.isActive ? "active" : "inactive"
                    }`}
                    onClick={() =>
                      setDropdownIndex(dropdownIndex === index ? null : index)
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="5"
                      height="5"
                      viewBox="0 0 5 5"
                      fill="none"
                    >
                      <circle
                        cx="2.5"
                        cy="2.5"
                        r="2.5"
                        fill={subuser.isActive ? "#00C27C" : "#FF4444"}
                      />
                    </svg>
                    <span
                      className={`status-text ${
                        subuser.isActive ? "active" : "inactive"
                      }`}
                    >
                      {subuser.isActive ? "Active" : "Inactive"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="7"
                      viewBox="0 0 11 7"
                      fill="none"
                    >
                      <path
                        d="M0.923949 0.597352L0.923949 0.597353C1.03978 0.466788 1.20337 0.385703 1.38234 0.385703C1.56126 0.385703 1.72482 0.466756 1.84065 0.597277L1.84054 0.597153L1.65371 0.763264L1.84072 0.597353L5.71459 4.95451L9.58845 0.597352C9.58847 0.597327 9.58849 0.597301 9.58852 0.597276L9.58863 0.597153L9.77546 0.763264C9.84801 0.681487 9.94541 0.634766 10.0468 0.634766C10.1483 0.634766 10.2457 0.680549 10.3182 0.762327L0.923949 0.597352ZM0.923949 0.597352L0.923704 0.597629C0.866782 0.661981 0.823192 0.736886 0.793959 0.817157C0.764728 0.897423 0.75 0.982595 0.75 1.06795C0.75 1.15331 0.764728 1.23848 0.793959 1.31875C0.823192 1.39902 0.866781 1.47392 0.923704 1.53827L0.923703 1.53827L0.924109 1.53873L5.24417 6.39873L5.24419 6.39876C5.36335 6.53277 5.53122 6.61572 5.71459 6.61572C5.89795 6.61572 6.06582 6.53277 6.18498 6.39876L6.18498 6.39875L10.5049 1.5398L0.923949 0.597352Z"
                        fill={subuser.isActive ? "#00C27C" : "#FF4444"}
                        stroke={subuser.isActive ? "#00C27C" : "#FF4444"}
                        strokeWidth="0.5"
                      />
                    </svg>
                  </button>
                  {dropdownIndex === index && (
                    <div className="dropdown-menu">
                      <div
                        className="dropdown-item active"
                        onClick={() => handleStatusChange(subuser, "Active")}
                      >
                        Active
                      </div>
                      <div
                        className="dropdown-item inactive"
                        onClick={() => handleStatusChange(subuser, "Inactive")}
                      >
                        Inactive
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row-item actions">
                <button
                  type="button"
                  className="edit-button"
                  onClick={() => handleEditUserClick(subuser.userId)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                  >
                    <path
                      d="M1.81916 8.95695L9.33913 1.43657C9.63622 1.15227 10.0328 0.995601 10.444 1.00009C10.8552 1.00459 11.2483 1.16989 11.5391 1.46061C11.8299 1.75133 11.9953 2.14435 11.9999 2.55552C12.0045 2.96669 11.8479 3.36332 11.5637 3.66048L4.04252 11.1809C3.87095 11.3524 3.65242 11.4694 3.41448 11.517L1 12L1.48302 9.58497C1.53061 9.34704 1.64757 9.12852 1.81916 8.95695Z"
                      stroke="#474747"
                      strokeWidth="1.46667"
                      strokeLinecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.06714 3.08984L9.91072 4.93337"
                      stroke="#474747"
                      strokeWidth="1.46667"
                    />
                  </svg>
                </button>
                {/*  
                <button
                  type="button"
                  className="action-button"
                  onClick={() => handleInativeUserClick(subuser)}
                >
                  {subuser.isActive ? "Inactive" : "Active"}
                </button> 
                */}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
